import _defineProperty from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray } from 'vega-util';
import { isFieldDef, isValueDef, vgField } from '../../channeldef';
import { DataSourceType } from '../../data';
import { isAggregate, pathGroupingFields } from '../../encoding';
import { AREA, BAR, isPathMark, LINE, TRAIL } from '../../mark';
import { isSortByEncoding, isSortField } from '../../sort';
import { contains, getFirstDefined, isNullOrFalse, keys, omit, pick } from '../../util';
import { VG_CORNERRADIUS_CHANNELS } from '../../vega.schema';
import { getMarkConfig, getMarkPropOrConfig, getStyles, signalOrValueRef, sortParams } from '../common';
import { arc } from './arc';
import { area } from './area';
import { bar } from './bar';
import { geoshape } from './geoshape';
import { image } from './image';
import { line, trail } from './line';
import { circle, point, square } from './point';
import { rect } from './rect';
import { rule } from './rule';
import { text } from './text';
import { tick } from './tick';
var markCompiler = {
  arc: arc,
  area: area,
  bar: bar,
  circle: circle,
  geoshape: geoshape,
  image: image,
  line: line,
  point: point,
  rect: rect,
  rule: rule,
  square: square,
  text: text,
  tick: tick,
  trail: trail
};
export function parseMarkGroups(model) {
  if (contains([LINE, AREA, TRAIL], model.mark)) {
    var details = pathGroupingFields(model.mark, model.encoding);

    if (details.length > 0) {
      return getPathGroups(model, details);
    } // otherwise use standard mark groups

  } else if (model.mark === BAR) {
    var hasCornerRadius = VG_CORNERRADIUS_CHANNELS.some(function (prop) {
      return getMarkPropOrConfig(prop, model.markDef, model.config);
    });

    if (model.stack && !model.fieldDef('size') && hasCornerRadius) {
      return getGroupsForStackedBarWithCornerRadius(model);
    }
  }

  return getMarkGroup(model);
}
var FACETED_PATH_PREFIX = 'faceted_path_';

function getPathGroups(model, details) {
  // TODO: for non-stacked plot, map order to zindex. (Maybe rename order for layer to zindex?)
  return [{
    name: model.getName('pathgroup'),
    type: 'group',
    from: {
      facet: {
        name: FACETED_PATH_PREFIX + model.requestDataName(DataSourceType.Main),
        data: model.requestDataName(DataSourceType.Main),
        groupby: details
      }
    },
    encode: {
      update: {
        width: {
          field: {
            group: 'width'
          }
        },
        height: {
          field: {
            group: 'height'
          }
        }
      }
    },
    // With subfacet for line/area group, need to use faceted data from above.
    marks: getMarkGroup(model, {
      fromPrefix: FACETED_PATH_PREFIX
    })
  }];
}

var STACK_GROUP_PREFIX = 'stack_group_';
/**
 * We need to put stacked bars into groups in order to enable cornerRadius for stacks.
 * If stack is used and the model doesn't have size encoding, we put the mark into groups,
 * and apply cornerRadius properties at the group.
 */

function getGroupsForStackedBarWithCornerRadius(model) {
  var _a; // Generate the mark


  var _getMarkGroup = getMarkGroup(model, {
    fromPrefix: STACK_GROUP_PREFIX
  }),
      _getMarkGroup2 = _slicedToArray(_getMarkGroup, 1),
      mark = _getMarkGroup2[0]; // Get the scale for the stacked field


  var fieldScale = model.scaleName(model.stack.fieldChannel);

  var stackField = function stackField() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return model.vgField(model.stack.fieldChannel, opt);
  }; // Find the min/max of the pixel value on the stacked direction


  var stackFieldGroup = function stackFieldGroup(func, expr) {
    var vgFieldMinMax = [stackField({
      prefix: 'min',
      suffix: 'start',
      expr: expr
    }), stackField({
      prefix: 'max',
      suffix: 'start',
      expr: expr
    }), stackField({
      prefix: 'min',
      suffix: 'end',
      expr: expr
    }), stackField({
      prefix: 'max',
      suffix: 'end',
      expr: expr
    })];
    return "".concat(func, "(").concat(vgFieldMinMax.map(function (field) {
      return "scale('".concat(fieldScale, "',").concat(field, ")");
    }).join(','), ")");
  };

  var groupUpdate;
  var innerGroupUpdate; // Build the encoding for group and an inner group

  if (model.stack.fieldChannel === 'x') {
    // Move cornerRadius, y/yc/y2/height properties to group
    // Group x/x2 should be the min/max of the marks within
    groupUpdate = Object.assign(Object.assign({}, pick(mark.encode.update, ['y', 'yc', 'y2', 'height'].concat(_toConsumableArray(VG_CORNERRADIUS_CHANNELS)))), {
      x: {
        signal: stackFieldGroup('min', 'datum')
      },
      x2: {
        signal: stackFieldGroup('max', 'datum')
      },
      clip: {
        value: true
      }
    }); // Inner group should revert the x translation, and pass height through

    innerGroupUpdate = {
      x: {
        field: {
          group: 'x'
        },
        mult: -1
      },
      height: {
        field: {
          group: 'height'
        }
      }
    }; // The marks should use the same height as group, without y/yc/y2 properties (because it's already done by group)
    // This is why size encoding is not supported yet

    mark.encode.update = Object.assign(Object.assign({}, omit(mark.encode.update, ['y', 'yc', 'y2'])), {
      height: {
        field: {
          group: 'height'
        }
      }
    });
  } else {
    groupUpdate = Object.assign(Object.assign({}, pick(mark.encode.update, ['x', 'xc', 'x2', 'width'])), {
      y: {
        signal: stackFieldGroup('min', 'datum')
      },
      y2: {
        signal: stackFieldGroup('max', 'datum')
      },
      clip: {
        value: true
      }
    });
    innerGroupUpdate = {
      y: {
        field: {
          group: 'y'
        },
        mult: -1
      },
      width: {
        field: {
          group: 'width'
        }
      }
    };
    mark.encode.update = Object.assign(Object.assign({}, omit(mark.encode.update, ['x', 'xc', 'x2'])), {
      width: {
        field: {
          group: 'width'
        }
      }
    });
  } // Deal with cornerRadius properties


  var _iterator = _createForOfIteratorHelper(VG_CORNERRADIUS_CHANNELS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var configValue = getMarkConfig(key, model.markDef, model.config); // Move from mark to group

      if (mark.encode.update[key]) {
        groupUpdate[key] = mark.encode.update[key];
        delete mark.encode.update[key];
      } else if (configValue) {
        groupUpdate[key] = signalOrValueRef(configValue);
      } // Overwrite any cornerRadius on mark set by config --- they are already moved to the group


      if (configValue) {
        mark.encode.update[key] = {
          value: 0
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var groupby = [];

  if (((_a = model.stack.groupbyChannels) === null || _a === void 0 ? void 0 : _a.length) > 0) {
    var _iterator2 = _createForOfIteratorHelper(model.stack.groupbyChannels),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var groupbyChannel = _step2.value;
        // For bin and time unit, we have to add bin/timeunit -end channels.
        var groupByField = model.fieldDef(groupbyChannel);
        var field = vgField(groupByField);

        if (field) {
          groupby.push(field);
        }

        if ((groupByField === null || groupByField === void 0 ? void 0 : groupByField.bin) || (groupByField === null || groupByField === void 0 ? void 0 : groupByField.timeUnit)) {
          groupby.push(vgField(groupByField, {
            binSuffix: 'end'
          }));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  var strokeProperties = ['stroke', 'strokeWidth', 'strokeJoin', 'strokeCap', 'strokeDash', 'strokeDashOffset', 'strokeMiterLimit', 'strokeOpacity']; // Generate stroke properties for the group

  groupUpdate = strokeProperties.reduce(function (encode, prop) {
    if (mark.encode.update[prop]) {
      return Object.assign(Object.assign({}, encode), _defineProperty({}, prop, mark.encode.update[prop]));
    } else {
      var configValue = getMarkConfig(prop, model.markDef, model.config);

      if (configValue !== undefined) {
        return Object.assign(Object.assign({}, encode), _defineProperty({}, prop, signalOrValueRef(configValue)));
      } else {
        return encode;
      }
    }
  }, groupUpdate); // Apply strokeForeground and strokeOffset if stroke is used

  if (groupUpdate.stroke) {
    groupUpdate.strokeForeground = {
      value: true
    };
    groupUpdate.strokeOffset = {
      value: 0
    };
  }

  return [{
    type: 'group',
    from: {
      facet: {
        data: model.requestDataName(DataSourceType.Main),
        name: STACK_GROUP_PREFIX + model.requestDataName(DataSourceType.Main),
        groupby: groupby,
        aggregate: {
          fields: [stackField({
            suffix: 'start'
          }), stackField({
            suffix: 'start'
          }), stackField({
            suffix: 'end'
          }), stackField({
            suffix: 'end'
          })],
          ops: ['min', 'max', 'min', 'max']
        }
      }
    },
    encode: {
      update: groupUpdate
    },
    marks: [{
      type: 'group',
      encode: {
        update: innerGroupUpdate
      },
      marks: [mark]
    }]
  }];
}

export function getSort(model) {
  var _a;

  var encoding = model.encoding,
      stack = model.stack,
      mark = model.mark,
      markDef = model.markDef,
      config = model.config;
  var order = encoding.order;

  if (!isArray(order) && isValueDef(order) && isNullOrFalse(order.value) || !order && isNullOrFalse(getMarkPropOrConfig('order', markDef, config))) {
    return undefined;
  } else if ((isArray(order) || isFieldDef(order)) && !stack) {
    // Sort by the order field if it is specified and the field is not stacked. (For stacked field, order specify stack order.)
    return sortParams(order, {
      expr: 'datum'
    });
  } else if (isPathMark(mark)) {
    // For both line and area, we sort values based on dimension by default
    var dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
    var dimensionChannelDef = encoding[dimensionChannel];

    if (isFieldDef(dimensionChannelDef)) {
      var s = dimensionChannelDef.sort;

      if (isArray(s)) {
        return {
          field: vgField(dimensionChannelDef, {
            prefix: dimensionChannel,
            suffix: 'sort_index',
            expr: 'datum'
          })
        };
      } else if (isSortField(s)) {
        return {
          field: vgField({
            // FIXME: this op might not already exist?
            // FIXME: what if dimensionChannel (x or y) contains custom domain?
            aggregate: isAggregate(model.encoding) ? s.op : undefined,
            field: s.field
          }, {
            expr: 'datum'
          })
        };
      } else if (isSortByEncoding(s)) {
        var fieldDefToSort = model.fieldDef(s.encoding);
        return {
          field: vgField(fieldDefToSort, {
            expr: 'datum'
          }),
          order: s.order
        };
      } else if (s === null) {
        return undefined;
      } else {
        return {
          field: vgField(dimensionChannelDef, {
            // For stack with imputation, we only have bin_mid
            binSuffix: ((_a = model.stack) === null || _a === void 0 ? void 0 : _a.impute) ? 'mid' : undefined,
            expr: 'datum'
          })
        };
      }
    }

    return undefined;
  }

  return undefined;
}

function getMarkGroup(model) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    fromPrefix: ''
  };
  var mark = model.mark,
      markDef = model.markDef,
      encoding = model.encoding,
      config = model.config;
  var clip = getFirstDefined(markDef.clip, scaleClip(model), projectionClip(model));
  var style = getStyles(markDef);
  var key = encoding.key;
  var sort = getSort(model);
  var interactive = interactiveFlag(model);
  var aria = getMarkPropOrConfig('aria', markDef, config);
  var postEncodingTransform = markCompiler[mark].postEncodingTransform ? markCompiler[mark].postEncodingTransform(model) : null;
  return [Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    name: model.getName('marks'),
    type: markCompiler[mark].vgMark
  }, clip ? {
    clip: true
  } : {}), style ? {
    style: style
  } : {}), key ? {
    key: key.field
  } : {}), sort ? {
    sort: sort
  } : {}), interactive ? interactive : {}), aria === false ? {
    aria: aria
  } : {}), {
    from: {
      data: opt.fromPrefix + model.requestDataName(DataSourceType.Main)
    },
    encode: {
      update: markCompiler[mark].encodeEntry(model)
    }
  }), postEncodingTransform ? {
    transform: postEncodingTransform
  } : {})];
}
/**
 * If scales are bound to interval selections, we want to automatically clip
 * marks to account for panning/zooming interactions. We identify bound scales
 * by the selectionExtent property, which gets added during scale parsing.
 */


function scaleClip(model) {
  var xScale = model.getScaleComponent('x');
  var yScale = model.getScaleComponent('y');
  return (xScale === null || xScale === void 0 ? void 0 : xScale.get('selectionExtent')) || (yScale === null || yScale === void 0 ? void 0 : yScale.get('selectionExtent')) ? true : undefined;
}
/**
 * If we use a custom projection with auto-fitting to the geodata extent,
 * we need to clip to ensure the chart size doesn't explode.
 */


function projectionClip(model) {
  var projection = model.component.projection;
  return projection && !projection.isFit ? true : undefined;
}
/**
 * Only output interactive flags if we have selections defined somewhere in our model hierarchy.
 */


function interactiveFlag(model) {
  if (!model.component.selection) return null;
  var unitCount = keys(model.component.selection).length;
  var parentCount = unitCount;
  var parent = model.parent;

  while (parent && parentCount === 0) {
    parentCount = keys(parent.component.selection).length;
    parent = parent.parent;
  }

  return parentCount ? {
    interactive: unitCount > 0 || !!model.encoding.tooltip
  } : null;
}